import { getDefaultShopConfig } from './default';
import { getConditionsFilterConfig } from '../filters/condition';
import * as custom from '../filters/marketplace-custom-config';
import { getSizeFilterConfig } from '../filters/size';
import { getColorFilterConfig } from '../filters/color';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { BuilderSections } from '../../util/builder';

const naadamSize = ['1X', '2X', '3X', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'OS'];

export const naadamShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getSizeFilterConfig({ sizes: naadamSize }),
    getColorFilterConfig(),
    getBrandDirectFilterConfig(),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.TopbarContent]: 'b6e2b1dae4d247b2a3417ae937cf9382',
      [BuilderSections.LandingPageContent]: '1fdba804af684a428c88d3ba6446f8de',
    },
  },
};
